import type {ThreadStatus} from 'nutshell-graphql-types';

import {StackLegacy} from '../../layout/stack/stack-legacy';
import {LoadingText} from '../../loading-placeholder/loading-text';

import {ThreadHeader} from '../thread-header/thread-header';
import type {Recipient, UpdateAction} from '../types';

import styles from './sidebar-header.module.css';

interface Props {
    isLoading: boolean;
    recipient: Recipient | null | undefined;
    onUpdateStatus: (action: UpdateAction) => Promise<any> | null | undefined;
    status: ThreadStatus | null | undefined;
    assigneeButton: React.ReactNode | null | undefined;
    openedFromEntityId?: string;
    shouldHidePickers: boolean;
}

export function ChatSidebarHeader(props: Props) {
    return (
        <div className={styles.header}>
            {props.isLoading ? (
                <div className='pad-16 flex flex-dir-col'>
                    <StackLegacy spacing={4}>
                        <LoadingText width={140} />
                        <LoadingText width={100} />
                    </StackLegacy>
                </div>
            ) : (
                <ThreadHeader
                    recipient={props.recipient}
                    canReopen={false}
                    canArchive={false}
                    assigneeButton={props.assigneeButton}
                    onUpdateStatus={props.onUpdateStatus}
                    status={props.status}
                    isSmall={true}
                    openedFromEntityId={props.openedFromEntityId}
                    shouldHidePickers={props.shouldHidePickers}
                />
            )}
        </div>
    );
}
